import Wrapper from "../../../layout/Wrapper";
import VehicleContractManageComponent from "../../../screens/contractControll/vehicleContract/renew";

import MetaComponent from "../../../components/common/MetaComponent";

const metadata = {
	title: "Management",
	description: "",
};

export default function Manage() {
	return (
		<Wrapper>
			<MetaComponent meta={metadata} />
			<VehicleContractManageComponent />
		</Wrapper>
	);
}